import {
  DashboardIcon,
  TeachersIcon,
  StudentsIcon,
  ContentCreatorsIcon,
  ContentStudioIcon,
  TenantsIcon,
  InstitutionsIcon,
  AnnouncementsIcon,
  AcademicSetupIcon,
  TimeTableIcon,
} from "@/shared/icons/SidebarIcons";
import {
  SCHOOL_ROLES,
  INSTITUTION_ROLES,
  INSTITUTION_DENIED_ROLES,
  ANNOUNCEMENT_ROLES,
  SCHOOL_USERS_NAV_ROLES,
  ACADEMIC_SETUP_ROLES,
  TIME_TABLE_ROLES,
} from "@/config/roleAccess";
import { UserRole } from "@/services/types/common.types";
import { TestIcon } from "@/shared/icons";

export type SidebarNavItem = {
  icon: React.ComponentType;
  label: string;
  key: string;
  disabled?: boolean;
  allowedRoles?: UserRole[];
  /** Users holding any of these roles never see the item, even with an allowed role. */
  deniedRoles?: UserRole[];
  /** Hidden items are not shown in the side menu (their routes keep working). */
  hidden?: boolean;
};

export const navItems: SidebarNavItem[] = [
  { icon: DashboardIcon, label: "sidebar.dashboard", key: "dashboard" },
  {
    icon: InstitutionsIcon,
    label: "sidebar.institutions",
    key: "institutions",
    allowedRoles: INSTITUTION_ROLES,
    deniedRoles: INSTITUTION_DENIED_ROLES,
  },
  {
    icon: TeachersIcon,
    label: "sidebar.teachers",
    key: "teachers",
    allowedRoles: SCHOOL_USERS_NAV_ROLES,
  },
  {
    icon: StudentsIcon,
    label: "sidebar.students",
    key: "students",
    allowedRoles: SCHOOL_USERS_NAV_ROLES,
  },
  {
    icon: AcademicSetupIcon,
    label: "sidebar.academicSetup",
    key: "academic-setup",
    allowedRoles: ACADEMIC_SETUP_ROLES,
  },
  {
    icon: TimeTableIcon,
    label: "sidebar.timeTable",
    key: "time-table",
    allowedRoles: TIME_TABLE_ROLES,
  },
  {
    icon: AnnouncementsIcon,
    label: "sidebar.announcements",
    key: "announcements",
    allowedRoles: ANNOUNCEMENT_ROLES,
  },
  {
    icon: TenantsIcon,
    label: "sidebar.tenants",
    key: "tenants",
    allowedRoles: SCHOOL_ROLES,
  },
  {
    icon: ContentCreatorsIcon,
    label: "sidebar.contentCreators",
    key: "content-creators",
    disabled: false,
    hidden: true,
  },
  {
    icon: ContentStudioIcon,
    label: "sidebar.contentStudio",
    key: "content-studio",
    allowedRoles: [UserRole.CREATOR, UserRole.ADMIN, UserRole.PLATFORM_ADMIN],
  },
  {
    icon: TestIcon,
    label: "sidebar.testPrep",
    key: "test-prep",
    allowedRoles: [UserRole.CREATOR],
  },
];
